import Service, { getCallApiFunction } from '../service'

interface BodyType {
  roomId: string
  productId: number
  count?: number
  memberInfoId?: string
  productImage?: string
  productName?: string
}

class CountProductClickApi extends Service {
  constructor(data: BodyType) {
    super()
    this.name = 'COUNT_PRODUCT_CLICK'

    this.config = {
      url: `/v1/room/product-click`,
      method: 'POST',
      data,
    }
  }
}

export const countProductClick = (data: BodyType) => getCallApiFunction(new CountProductClickApi(data))
